













































































































































import mixins from 'vue-typed-mixins';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
import ParticipationForm from '@/components/survey/management/ParticipationForm.vue';
import ParticipationFilter from '@/components/survey/management/ParticipationFilter.vue';
import SurveyParticipationBulkEdit from '@/components/survey/management/SurveyParticipationBulkEdit.vue';
import cloneDeep from 'lodash.clonedeep';
import SurveyUtils, {
  Survey,
  SurveyParticipation,
  SurveyGroup,
  Question,
} from '@/utils/SurveyUtils';
import ProviderUtils, { ServiceProvider } from '@/utils/ProviderUtils';
export default mixins().extend({
  components: {
    ParticipationForm,
    ParticipationFilter,
    SurveyParticipationBulkEdit,
  },
  props: {
    value: {
      type: Object as () => Survey,
    },
  },
  computed: {
    participationItems(): SurveyParticipation[] | undefined {
      // return this.participations?.filter((participation) => true);
      return this.participations;
    },
    participationHeaders(): DataTableHeader<SurveyParticipation>[] {
      return [
        {
          text: this.$i18n.tc('model.serviceProvider.label'),
          value: 'serviceprovider.name',
        },
        {
          text: this.$i18n.tc('model.oversightOrganization.label'),
          value: 'serviceprovider.parent.name',
        },
        {
          text: this.$i18n.tc('model.common.state'),
          value: 'state',
        },
        {
          text: this.$i18n.tc('model.surveyParticipation.submissionstate'),
          value: 'submissionstate.name',
        },
      ];
    },
    providerItems(): ServiceProvider[] | undefined {
      if (!this.providers) {
        return undefined;
      } else {
        let providers = Array.from(this.providers);

        providers = providers?.filter((participation) => {
          if (
            this.value.filter?.providerTypes &&
            this.value.filter.providerTypes.length > 0
          ) {
            return this.value.filter?.providerTypes?.includes(
              participation.serviceprovidertype.id as number
            );
          } else {
            return true;
          }
        });

        providers = providers?.filter((participation) => {
          if (
            this.value.filter?.oversights &&
            this.value.filter.oversights.length > 0
          ) {
            return this.value.filter?.oversights?.some((parentId) =>
              participation.parent.some(
                (oversight) => oversight.id === parentId
              )
            );
          } else {
            return true;
          }
        });

        return providers;
      }
    },
    providerHeaders(): any {
      return [
        {
          text: this.$i18n.tc('model.common.name'),
          value: 'name',
        },
        {
          text: this.$i18n.tc('model.serviceProviderType.label'),
          value: 'serviceprovidertype.name',
        },
        {
          text: this.$i18n.tc('model.oversightOrganization.label'),
          value: 'parent.name',
        },
      ];
    },
    optionsGroupsOptions(): any {
      return this.options?.data?.surveyGroups?.map((group) => ({
        text: group.name,
        value: group,
      }));
    },
    optionsQuestionsOptions(): any {
      return this.options?.data?.questions?.map((question) => ({
        text: question.questionkey,
        value: question,
      }));
    },
  },
  data(): {
    state: boolean;
    participations?: SurveyParticipation[];
    providers?: ServiceProvider[];
    participation?: SurveyParticipation;
    options: {
      group?: SurveyGroup;
      questions?: Question[];
      participation?: SurveyParticipation;
      data: {
        surveyGroups?: SurveyGroup[];
        questions?: Question[];
      };
    };
    selected: ServiceProvider[];
  } {
    return {
      state: false,
      participations: undefined,
      providers: undefined,
      participation: undefined,
      options: {
        group: undefined,
        questions: undefined,
        data: {
          surveyGroups: undefined,
          questions: undefined,
        },
      },
      selected: [],
    };
  },
  async mounted() {
    this.reload();
  },
  methods: {
    setState(state: boolean) {
      this.state = state;
    },

    async reload() {
      try {
        this.participations = undefined;
        this.providers = undefined;

        const resp = await Promise.all([
          SurveyUtils.api.surveyParticipation.list({
            surveyid: this.value.id,
          }),
          ProviderUtils.api.instance.list(),
        ]);

        // fill the participations with the full provider objects
        this.participations = resp[0].map((participation) => ({
          ...participation,
          serviceprovider: resp[1]?.find(
            (provider) => provider.id === participation.serviceprovider.id
          ) as ServiceProvider,
        }));

        // remove the providers already assigned to participations from the providers array
        this.providers = resp[1].filter(
          (provider) =>
            !resp[0]?.some(
              (participation) =>
                participation.serviceprovider.id === provider.id
            )
        );
      } catch (error) {
        this.$alert.show('reload', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    edit(participation: SurveyParticipation) {
      this.participation = participation;
    },

    async submit(participant: SurveyParticipation) {
      try {
        this.$alert.hide('submit');
        await SurveyUtils.api.surveyParticipation.update(participant);
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [participant.serviceprovider.name],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
      await this.reload();
    },

    async remove(participation: SurveyParticipation) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [
            this.$translate(participation.serviceprovider.name),
          ])
          .toString(),
        async () => {
          if (participation.id && this.participations) {
            this.$alert.hide('remove');
            await SurveyUtils.api.surveyParticipation.remove(participation.id);
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [participation.serviceprovider.name],
              }),
            });
            // add the service provider to the providers array so it can be readded
            this.providers?.push(
              participation.serviceprovider as ServiceProvider
            );

            const index = this.participations.findIndex(
              (val) => val.id === participation.id
            );
            if (index >= 0) {
              this.participations.splice(index, 1);
            }
          }
        }
      );
    },

    async showOptions(participation?: SurveyParticipation) {
      this.options.participation = participation;
      this.options.group = undefined;
      this.options.questions = undefined;
      (this.$refs.optionsModal as any).open();
      try {
        const resp = await Promise.all([
          this.options.data.surveyGroups === undefined
            ? SurveyUtils.api.surveyGroup.list()
            : this.options.data.surveyGroups,
          this.options.data.questions === undefined
            ? SurveyUtils.api.question.list({
                surveyid: this.value.id,
              })
            : this.options.data.questions,
        ]);
        this.options.data.surveyGroups = resp[0];
        this.options.data.questions = resp[1];
      } catch (error) {
        (this.$refs.optionsAlert as any).show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async duplicateAnswers() {
      try {
        (this.$refs.optionsAlert as any).hide('duplicateAnswers');
        await SurveyUtils.api.surveyParticipation.duplicate({
          survey: this.value,
          surveyparticipation: [
            this.options.participation as SurveyParticipation,
          ],
          surveygroup: this.options.group,
          serviceprovider: this.options.participation?.serviceprovider,
          questions: this.options.questions,
        });
        (this.$refs.optionsModal as any).resolve();
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.copy', {
            values: [this.$languageobj('model.question.label', { choice: 2 })],
          }),
        });
      } catch (error) {
        (this.$refs.optionsAlert as any).show('duplicateAnswers', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async addParticipants() {
      try {
        (this.$refs.optionsAlert as any).hide('add');
        const selected = await SurveyUtils.api.surveyParticipation.add(
          this.value.id as number,
          this.selected.map((provider) => ({ id: provider.id })),
          this.options.group?.id,
          this.options.questions
        );

        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [
              this.$languageobjArray(
                this.selected.map((provider) => provider.name)
              ),
            ],
          }),
        });

        (this.$refs.optionsModal as any).resolve();
        this.setState(false);
        this.selected = [];
        this.reload();
      } catch (error) {
        (this.$refs.optionsAlert as any).show('add', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    handlePristine(pristine: Partial<Survey>) {
      this.$emit('pristine', pristine);
    },

    async view(participation: Partial<SurveyParticipation>) {
      await this.$router.push({
        name: 'survey-report',
        params: {
          participantId: participation?.id?.toString() || '',
        },
      });
    },
  },
});
